import { prop } from "ramda";
import { getDevicesList } from "../../services/apis";
import { isServerResponseError, hasError } from "../common";

const getDevicesListData = async (page, limit, orderBy, date) => {
  const result = await getDevicesList({
    page,
    limit,
    orderBy,
    date,
  });
  return isServerResponseError(result) || hasError(result)
    ? {
        total: 0,
        data: [],
      }
    : prop("data", result);
};

export default getDevicesListData;
